import { CommonEnums } from '../../../app/shared/common.enums';
import { Obj_Db_Property } from '../models/datapoint/obj_db_property';
import { Db_PropertyType } from '../models/datapoint/dbPropertyType'
import { Obj_Db_PropertyUtil } from '../utils/obj_db_property.util';
import { Db_PropertyTypesUtil } from '../utils/db_propertytypes.util';
import { Obj_Db_PropertiesUtil } from '../utils/obj_db_properties.util';

export class Conn_Db_Obj_Lnk {
    conn_Id: number;
    dxFlow_Id: number;
    dxMp_Inst_Id: number;
    obj_Id: number;
    conn_Db_Id: number;
    obj_Cd: string;
    conn_Nm: string;
    conn_Db_Nm: string;
    objNm: string;
    imageUrl: string;
    fldr_Id: number;
    fldrNm: string;
    dbTyp_Id: number;
    host: string;
    port: string;
    conn_Usr: string;
    secKeyTab: string;
    platform: string;
    hiveServe2HACnf_Flg: string;
    zookeeper_Quorum_Host: string;
    extract_Properties: Array<Obj_Db_Property>;
    load_Properties: Array<Obj_Db_Property>;
    partition_Properties: Array<Obj_Db_Property>;
    sel_Extract_PropertyType_Cd: string;
    sel_Load_PropertyType_Cd: string;
    copy_Sel_Extract_PropertyType_Cd: string;
    copy_Sel_Load_PropertyType_Cd: string;
    extractPropertyTypes: Array<Db_PropertyType>;
    loadPropertyTypes: Array<Db_PropertyType>;
    databaseNm: string;
    conn_Db_FriendlyName: string;
    group_Id: number;
    conn_Valid_Cd: string;
    metaData_Properties: Array<Obj_Db_Property>;
    instSqlNm: string;
    connType: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.conn_Id = CommonEnums.defaults.LONG_VAL;
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.obj_Id = CommonEnums.defaults.LONG_VAL;
        this.conn_Db_Id = CommonEnums.defaults.LONG_VAL;
        this.obj_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Nm = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Db_Nm = CommonEnums.defaults.STRING_EMPTY;
        this.objNm = CommonEnums.defaults.STRING_EMPTY;
        this.imageUrl = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.fldrNm = CommonEnums.defaults.STRING_EMPTY;
        this.dbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.host = CommonEnums.defaults.STRING_EMPTY;
        this.port = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Usr = CommonEnums.defaults.STRING_EMPTY;
        this.secKeyTab = CommonEnums.defaults.STRING_EMPTY;
        this.platform = CommonEnums.defaults.STRING_EMPTY;
        this.hiveServe2HACnf_Flg = CommonEnums.defaults.STRING_EMPTY;
        this.zookeeper_Quorum_Host = CommonEnums.defaults.STRING_EMPTY;
        this.extract_Properties = new Array<Obj_Db_Property>();
        this.load_Properties = new Array<Obj_Db_Property>();
        this.partition_Properties = new Array<Obj_Db_Property>();
        this.sel_Extract_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.sel_Load_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.copy_Sel_Extract_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.copy_Sel_Load_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.extractPropertyTypes = new Array<Db_PropertyType>();
        this.loadPropertyTypes = new Array<Db_PropertyType>();
        this.databaseNm = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Db_FriendlyName = CommonEnums.defaults.STRING_EMPTY;
        this.group_Id = CommonEnums.defaults.LONG_VAL;
        this.conn_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.metaData_Properties = new Array<Obj_Db_Property>();
        this.instSqlNm = CommonEnums.defaults.STRING_EMPTY;
        this.connType = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(object: Conn_Db_Obj_Lnk): Conn_Db_Obj_Lnk {
        let _conn_Db_Obj_Lnk = new Conn_Db_Obj_Lnk();
        _conn_Db_Obj_Lnk.copyFrom(object as Conn_Db_Obj_Lnk)
        return _conn_Db_Obj_Lnk;
    }

    copy(): Conn_Db_Obj_Lnk {
        let conn_Db_Obj_LnkTmp: Conn_Db_Obj_Lnk = new Conn_Db_Obj_Lnk();

        conn_Db_Obj_LnkTmp.conn_Id = this.conn_Id;
        conn_Db_Obj_LnkTmp.dxFlow_Id = this.dxFlow_Id;
        conn_Db_Obj_LnkTmp.dxMp_Inst_Id = this.dxMp_Inst_Id;
        conn_Db_Obj_LnkTmp.obj_Id = this.obj_Id;
        conn_Db_Obj_LnkTmp.conn_Db_Id = this.conn_Db_Id;
        conn_Db_Obj_LnkTmp.obj_Cd = this.obj_Cd;
        conn_Db_Obj_LnkTmp.conn_Nm = this.conn_Nm;
        conn_Db_Obj_LnkTmp.conn_Db_Nm = this.conn_Db_Nm;
        conn_Db_Obj_LnkTmp.objNm = this.objNm;
        conn_Db_Obj_LnkTmp.imageUrl = this.imageUrl;
        conn_Db_Obj_LnkTmp.fldr_Id = this.fldr_Id;
        conn_Db_Obj_LnkTmp.fldrNm = this.fldrNm;
        conn_Db_Obj_LnkTmp.dbTyp_Id = this.dbTyp_Id;
        conn_Db_Obj_LnkTmp.host = this.host;
        conn_Db_Obj_LnkTmp.port = this.port;
        conn_Db_Obj_LnkTmp.conn_Usr = this.conn_Usr;
        conn_Db_Obj_LnkTmp.secKeyTab = this.secKeyTab;
        conn_Db_Obj_LnkTmp.platform = this.platform;
        conn_Db_Obj_LnkTmp.hiveServe2HACnf_Flg = this.hiveServe2HACnf_Flg;
        conn_Db_Obj_LnkTmp.zookeeper_Quorum_Host = this.zookeeper_Quorum_Host;
        conn_Db_Obj_LnkTmp.extract_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.extract_Properties);
        conn_Db_Obj_LnkTmp.load_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.load_Properties);
        conn_Db_Obj_LnkTmp.partition_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.partition_Properties);
        conn_Db_Obj_LnkTmp.sel_Extract_PropertyType_Cd = this.sel_Extract_PropertyType_Cd;
        conn_Db_Obj_LnkTmp.sel_Load_PropertyType_Cd = this.sel_Load_PropertyType_Cd;
        conn_Db_Obj_LnkTmp.copy_Sel_Extract_PropertyType_Cd = this.copy_Sel_Extract_PropertyType_Cd;
        conn_Db_Obj_LnkTmp.copy_Sel_Load_PropertyType_Cd = this.copy_Sel_Load_PropertyType_Cd;
        conn_Db_Obj_LnkTmp.extractPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.extractPropertyTypes);
        conn_Db_Obj_LnkTmp.loadPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.loadPropertyTypes);
        conn_Db_Obj_LnkTmp.databaseNm = this.databaseNm;
        conn_Db_Obj_LnkTmp.conn_Db_FriendlyName = this.conn_Db_FriendlyName;
        conn_Db_Obj_LnkTmp.group_Id = this.group_Id;
        conn_Db_Obj_LnkTmp.conn_Valid_Cd = this.conn_Valid_Cd;
        conn_Db_Obj_LnkTmp.metaData_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.metaData_Properties);
        conn_Db_Obj_LnkTmp.instSqlNm = this.instSqlNm;
        conn_Db_Obj_LnkTmp.connType = this.connType;

        return conn_Db_Obj_LnkTmp;

    }

    copyFrom(conn_Db_Obj_LnkTmp: Conn_Db_Obj_Lnk): void {
        this.conn_Id = conn_Db_Obj_LnkTmp.conn_Id;
        this.dxFlow_Id = conn_Db_Obj_LnkTmp.dxFlow_Id;
        this.dxMp_Inst_Id = conn_Db_Obj_LnkTmp.dxMp_Inst_Id;
        this.obj_Id = conn_Db_Obj_LnkTmp.obj_Id;
        this.conn_Db_Id = conn_Db_Obj_LnkTmp.conn_Db_Id;
        this.obj_Cd = conn_Db_Obj_LnkTmp.obj_Cd;
        this.conn_Nm = conn_Db_Obj_LnkTmp.conn_Nm;
        this.conn_Db_Nm = conn_Db_Obj_LnkTmp.conn_Db_Nm;
        this.objNm = conn_Db_Obj_LnkTmp.objNm;
        this.imageUrl = conn_Db_Obj_LnkTmp.imageUrl;
        this.fldr_Id = conn_Db_Obj_LnkTmp.fldr_Id;
        this.fldrNm = conn_Db_Obj_LnkTmp.fldrNm;
        this.dbTyp_Id = conn_Db_Obj_LnkTmp.dbTyp_Id;
        this.host = conn_Db_Obj_LnkTmp.host;
        this.port = conn_Db_Obj_LnkTmp.port;
        this.conn_Usr = conn_Db_Obj_LnkTmp.conn_Usr;
        this.secKeyTab = conn_Db_Obj_LnkTmp.secKeyTab;
        this.platform = conn_Db_Obj_LnkTmp.platform;
        this.hiveServe2HACnf_Flg = conn_Db_Obj_LnkTmp.hiveServe2HACnf_Flg;
        this.zookeeper_Quorum_Host = conn_Db_Obj_LnkTmp.zookeeper_Quorum_Host;
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.extract_Properties, conn_Db_Obj_LnkTmp.extract_Properties);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.load_Properties, conn_Db_Obj_LnkTmp.load_Properties);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.partition_Properties, conn_Db_Obj_LnkTmp.partition_Properties);
        this.sel_Extract_PropertyType_Cd = conn_Db_Obj_LnkTmp.sel_Extract_PropertyType_Cd;
        this.sel_Load_PropertyType_Cd = conn_Db_Obj_LnkTmp.sel_Load_PropertyType_Cd;
        this.copy_Sel_Extract_PropertyType_Cd = conn_Db_Obj_LnkTmp.copy_Sel_Extract_PropertyType_Cd;
        this.copy_Sel_Load_PropertyType_Cd = conn_Db_Obj_LnkTmp.copy_Sel_Load_PropertyType_Cd;
        Db_PropertyTypesUtil.getInstance().copyFrom(this.extractPropertyTypes, conn_Db_Obj_LnkTmp.extractPropertyTypes);
        Db_PropertyTypesUtil.getInstance().copyFrom(this.loadPropertyTypes, conn_Db_Obj_LnkTmp.loadPropertyTypes);
        this.databaseNm = conn_Db_Obj_LnkTmp.databaseNm;
        this.conn_Db_FriendlyName = conn_Db_Obj_LnkTmp.conn_Db_FriendlyName;
        this.group_Id = conn_Db_Obj_LnkTmp.group_Id;
        this.conn_Valid_Cd = conn_Db_Obj_LnkTmp.conn_Valid_Cd;
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.metaData_Properties, conn_Db_Obj_LnkTmp.metaData_Properties);
        this.instSqlNm = conn_Db_Obj_LnkTmp.instSqlNm;
        this.connType = conn_Db_Obj_LnkTmp.connType;
    }

    compare(conn_Db_Obj_LnkTmp: Conn_Db_Obj_Lnk): string {
        let diffString = '';
        let conn_Db_Obj_LnkString: string = this.toString(true);
        let conn_Db_Obj_LnkTmpString: string = conn_Db_Obj_LnkTmp.toString(true);

        if (conn_Db_Obj_LnkString != conn_Db_Obj_LnkTmpString) {
            diffString =  conn_Db_Obj_LnkString + ', ' + conn_Db_Obj_LnkTmpString;
            return diffString;
        }

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.extract_Properties, conn_Db_Obj_LnkTmp.extract_Properties);
        if(diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.load_Properties, conn_Db_Obj_LnkTmp.load_Properties);
        if(diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.partition_Properties, conn_Db_Obj_LnkTmp.partition_Properties);
        if(diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.metaData_Properties, conn_Db_Obj_LnkTmp.metaData_Properties);
        if(diffString != '') return diffString;

        diffString = Db_PropertyTypesUtil.getInstance().compare(this.extractPropertyTypes, conn_Db_Obj_LnkTmp.extractPropertyTypes);
        if(diffString != '') return diffString;

        diffString = Db_PropertyTypesUtil.getInstance().compare(this.loadPropertyTypes, conn_Db_Obj_LnkTmp.loadPropertyTypes);
        if(diffString != '') return diffString;
        

        return diffString;
    }

    toString(isNotCompare: boolean = true): string {
        let str: string= "Conn_Db_Obj_Lnk [conn_Id=" + this.conn_Id + ", dxFlow_Id=" + this.dxFlow_Id + ", dxMp_Inst_Id=" + this.dxMp_Inst_Id +
            ", obj_Id =" + this.obj_Id + ", conn_Db_Id=" + this.conn_Db_Id + ", obj_Cd=" + this.obj_Cd;

            if (isNotCompare) {

              str +=  ", conn_Nm=" + this.conn_Nm + ", conn_Db_Nm=" + this.conn_Db_Nm +
            ", objNm=" + this.objNm + ", imageUrl=" + this.imageUrl + ", fldr_Id=" + this.fldr_Id + ", fldrNm=" + this.fldrNm +
            ", dbTyp_Id=" + this.dbTyp_Id + ", host=" + this.host + ", port=" + this.port +
            ", conn_Usr=" + this.conn_Usr + ", secKeyTab=" + this.secKeyTab + ", platform=" + this.platform +
            ", hiveServe2HACnf_Flg=" + this.hiveServe2HACnf_Flg + ", zookeeper_Quorum_Host=" + this.zookeeper_Quorum_Host +
            ", sel_Extract_PropertyType_Cd=" + this.sel_Extract_PropertyType_Cd +
            ", sel_Load_PropertyType_Cd=" + this.sel_Load_PropertyType_Cd +
            ", copy_Sel_Extract_PropertyType_Cd=" + this.copy_Sel_Extract_PropertyType_Cd +
            ", copy_Sel_Load_PropertyType_Cd=" + this.copy_Sel_Load_PropertyType_Cd +
            ", databaseNm=" + this.databaseNm + ", conn_Db_FriendlyName=" + this.conn_Db_FriendlyName +
            ", group_Id=" + this.group_Id + ", conn_Valid_Cd=" + this.conn_Valid_Cd +
            ", instSqlNm=" + this.instSqlNm + ", connType=" + this.connType;
        }
        str += ']';
        return str;
    }
}
 
    
